import { OrderStatusEsEnum } from "@edp-enums/ES/order-status-es-enum";
import { FormatDate } from "@edp-utils/format-date.util";

export interface OrderEsSubStep {
    active: boolean;
    description: string;
    hide?: boolean;
}

export interface OrderEsStep {
    title: string;
    icon: string;
    modal?: string;
    substeps: Array<OrderEsSubStep>;
}

export class OrderEs {
    public isCanceled = false;
    public isCompleted = false;
    public indexStepActive: number;
    public formatAppointmentDate: string;
    public formatDate: string;
    public formatInstallationDate: string;

    constructor(
        public clientType: string,
        public color: string,
        public color_detail: string,
        public current_step_status: string,
        public date: Date,
        public description: string,
        public description_detail: string,
        public icon: string,
        public stage: string,
        public status: string,
        public status_key: OrderStatusEsEnum,
        public steps: Array<OrderEsStep>,
        public title: string,
        public contractId: string,
        public appointmentDateActive: boolean,
        public appointmentDate: Date | null,
        public installationDateActive: boolean,
        public installationDate: Date | null,
        public appointmentButtonShow?: boolean,
        public installationButtonShow?: boolean,
        public forceCheckedStep?: boolean
    ) {
        this.isCanceled = status_key === OrderStatusEsEnum.CANCELED;
        this.isCompleted = status_key === OrderStatusEsEnum.COMPLETED;
        this.indexStepActive = steps.findIndex(i => !!i.substeps.find(s => !!s.active));
        if (this.isCanceled) {
            this.steps[this.indexStepActive].icon = `${this.steps[this.indexStepActive].icon}-cancelled`;
        }
        this.formatDate = FormatDate.getFormattedDayMonthES(date);
        this.formatAppointmentDate = FormatDate.getFormattedDayMonthYearES(appointmentDate);
        this.formatInstallationDate = FormatDate.getFormattedDayMonthYearES(installationDate);
    }
}

export class OrderEsFactory {
    static create(order: OrderEs) {
        return new OrderEs(
            order.clientType,
            order.color,
            order.color_detail,
            order.current_step_status,
            order.date,
            order.description,
            order.description_detail,
            order.icon,
            order.stage,
            order.status,
            order.status_key,
            order.steps,
            order.title,
            order.contractId,
            order.appointmentDateActive,
            order.appointmentDate,
            order.installationDateActive,
            order.installationDate,
            order.appointmentButtonShow,
            order.installationButtonShow,
            order.forceCheckedStep
        );
    }
}
